export default "__VITE_ASSET__BXu$wtI1__"